export type RateUnit = 'hour' | 'minute'
export type LevelEtaMode = 'realtime' | 'average'
export type OcrRecognitionModel = 'small' | 'tiny'

export const normalizeLevelEtaMode = (value: unknown): LevelEtaMode => value === 'average' ? 'average' : 'realtime'
export const normalizeRateUnit = (value: unknown): RateUnit => value === 'minute' ? 'minute' : 'hour'
export const normalizeOcrRecognitionModel = (value: unknown): OcrRecognitionModel => value === 'tiny' ? 'tiny' : 'small'

/** Stored rates and all accounting remain hourly. Convert only at the display boundary. */
export function displayRate(value: number | null | undefined, unit: RateUnit = 'hour'): number | null {
  return value == null || !Number.isFinite(value) ? null : value / (unit === 'minute' ? 60 : 1)
}

export function formatRate(value: number | null | undefined, locale: string, unit: RateUnit = 'hour',
  options: Intl.NumberFormatOptions = {}): string {
  const converted = displayRate(value, unit)
  if (converted === null) return '--'
  return Intl.NumberFormat(locale, { notation: 'compact', maximumFractionDigits: 2, ...options }).format(converted)
}
